import { useLocale } from '@/hooks/useLocale';

type Locale = ReturnType<typeof useLocale>;

/**
 * Convert an absolute canonical URL to a locale-base url.
 *
 * Used when only the canonical URL is available to form a route link for company report. The canonical URL is always sans any locale param.
 * Prefer using the `useCompanyReportPageUrl` hook to obtain the report page url where possible.
 */
export function toLocaleUrl<U extends string = string | ''>(
  locale: Locale,
  canonicalUrl: U
) {
  // English locale uses the same url as 'standard' non-locale - e.g. no locale param
  if (locale === 'en' || canonicalUrl === '') {
    return canonicalUrl;
  }
  // Prepend the locale param with the expectation that the canonical URL is formed as `/stocks/....`
  return `/${locale}${canonicalUrl}` as `/${Exclude<Locale, 'en'>}${Exclude<
    U,
    ''
  >}`;
}
